import { css } from '@emotion/react'
import { colors, measures, spacing } from 'styles/variables'

const { unit } = measures

export const container = css`
  margin-bottom: ${spacing(3)};
`

export const filtersWrapper = css`
  display: flex;
  gap: ${spacing(1)};
  overflow-x: auto;
  padding: ${spacing(0, 0, 1, 0)};
  
  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const filterPill = css`
  display: flex;
  align-items: center;
  gap: ${spacing(0.75)};
  padding: ${spacing(1.5, 1.5)};
  border-radius: ${spacing(2)};
  border: 1px solid ${colors.grays.gray7};
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background-color: ${colors.grays.gray9};
  }
  
  &:focus {
    outline: none;
    border-color: #00d4aa;
  }
`

export const filterPillActive = css`
  background-color: #00d4aa;
  border-color: #00d4aa;
  
  &:hover {
    background-color: #00b896;
  }
`

export const filterText = css`
  color: ${colors.white60};
  line-height: 1;
`

export const filterTextActive = css`
  color: ${colors.white100};
` 